export const editBaseRouter = [
    {
        path: '/editBaseInfo',
        name: 'editBaseInfo',
        component: () => import(/* webpackChunkName: "about" */ '@/views/editBase/editBaseInfo.vue'),
        meta: {
            title: '升学规划系统'
        },
    },
    {
        path: '/editScore',
        name: 'editScore',
        component: () => import(/* webpackChunkName: "about" */ '@/views/editBase/editScore.vue'),
        meta: {
            title: '升学规划系统'
        },
    },
    {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "about" */ '@/views/editBase/login.vue'),
        meta: {
            title: '升学规划系统'
        },
    },
    {
        path: '/register',
        name: 'register',
        component: () => import(/* webpackChunkName: "about" */ '@/views/editBase/register.vue'),
        meta: {
            title: '升学规划系统'
        },
    },
    {
        path: '/resetPass',
        name: 'resetPass',
        component: () => import(/* webpackChunkName: "about" */ '@/views/editBase/resetPass.vue'),
        meta: {
            title: '升学规划系统'
        },
    },



]